function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6639 5.22607C9.35355 5.32952 7.20696 8.84681 2.68105 10.7865C1.51725 11.433 1 12.5968 1.25864 16.2176C1.46134 19.0552 4.49143 19.9676 5.00868 19.9676C5.42248 19.9676 24.0606 19.7952 33.3279 19.709C34.1469 19.7521 35.371 19.0366 35.7848 18.4159C36.5607 17.2521 36.69 15.8296 36.4314 14.2779C36.2245 13.0365 34.4486 11.5623 33.5865 11.3037C29.8365 10.6572 29.0606 10.7865 28.1555 10.0106C27.0447 9.05849 22.4948 5.39495 21.8192 5.22607C20.7847 4.96746 10.0518 5.09675 9.6639 5.22607ZM9.6639 5.22607C8.6294 4.53641 6.32764 3.02779 5.3966 2.51054C4.23279 1.86398 3.06899 0.182929 1 1.47605",
  stroke: "#BBD422",
  strokeWidth: 1.48121,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 13.3359,
  y: 11.4336,
  width: 6,
  height: 2,
  rx: 0.888724,
  fill: "#BBD422"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.11196,
  cy: 19.1915,
  rx: 3.49142,
  ry: 3.49141,
  fill: "#BBD422"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.9904,
  cy: 19.1915,
  rx: 3.49142,
  ry: 3.49141,
  fill: "#BBD422"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.11097,
  cy: 19.1919,
  rx: 2.45692,
  ry: 2.45692,
  fill: "#FAFBFB"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.9912,
  cy: 19.1919,
  rx: 2.45692,
  ry: 2.45692,
  fill: "#FAFBFB"
});

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 23,
    viewBox: "0 0 38 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.dbac3a2e.svg";
export { ForwardRef as ReactComponent };